import { Navigate, Outlet } from "react-router-dom";

import { UserProfileSettingsPage } from "./user-profile-settings.page";
import { UserSecuritySettingsPage } from "./user-security-settings.page";

export const userSettingsRoutes = [
  {
    path: "account",
    element: <Outlet />,
    children: [
      { path: "", element: <Navigate to="profile" replace /> },
      {
        path: "profile",
        element: <UserProfileSettingsPage />,
      },
      {
        path: "security",
        element: <UserSecuritySettingsPage />,
      },
    ],
  },
];
